import { useUser } from '../../contexts/UserContext'
import { SearchTab } from '../../components/RAG/Tabs/SearchTab'

export function SearchPage() {
    const { session } = useUser()

    return <SearchTab session={session} />
}
